import { Box, Paper, Stack, Typography } from "@mui/material";
import { motion, type Variants } from "framer-motion";

import { colors } from "@components/ui/colors";

const MotionBox = motion(Box);
const MotionPaper = motion(Paper);

export const metricsContainerAnimation: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.06,
    },
  },
};

export const metricCardAnimation: Variants = {
  hidden: {
    opacity: 0,
    y: 12,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.28,
      ease: "easeOut",
    },
  },
};

interface MetricCardProps {
  label: string;
  value: React.ReactNode;
  helper: string;
  icon: React.ReactNode;
}

export const MetricCard = ({ label, value, helper, icon }: MetricCardProps) => {
  return (
    <MotionPaper
      elevation={0}
      variants={metricCardAnimation}
      sx={{
        height: "100%",
        bgcolor: "var(--fx-surface-base, #FFFFFF)",
        borderRadius: 3,
        p: 1.75,
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
        <Box>
          <Typography
            sx={{
              color: "var(--fx-surface-texttertiary, #94A3B8)",
              fontSize: "0.625rem",
              fontWeight: 800,
              textTransform: "uppercase",
              letterSpacing: "0.06em",
            }}
          >
            {label}
          </Typography>

          <Typography
            sx={{
              color: "var(--fx-surface-text, #0F172A)",
              fontSize: "1.45rem",
              fontWeight: 850,
              lineHeight: 1.2,
              mt: 0.6,
            }}
          >
            {value}
          </Typography>

          <Typography
            sx={{
              color: "var(--fx-surface-textsecondary, #64748B)",
              fontSize: "0.6875rem",
              fontWeight: 600,
              mt: 0.35,
            }}
          >
            {helper}
          </Typography>
        </Box>

        <MotionBox
          whileHover={{
            scale: 1.08,
            rotate: 4,
          }}
          transition={{
            duration: 0.18,
          }}
          sx={{
            width: 38,
            height: 38,
            borderRadius: 2,
            display: "grid",
            placeItems: "center",
            bgcolor: colors.orange[50],
            flexShrink: 0,
            "& svg": {
              fontSize: 20,
            },
          }}
        >
          {icon}
        </MotionBox>
      </Stack>
    </MotionPaper>
  );
};
